// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"750px","tabletWidth":"1200px"};